var styles = {"icon":"VDS__MON__icon-base-module__DAtvV"};

export { styles as default };
